import styled, { keyframes } from 'styled-components';
import Client1 from '../../assets/client1.png';
import Client10 from '../../assets/client10.png';
import Client11 from '../../assets/client11.png';
import Client12 from '../../assets/client12.png';
import Client13 from '../../assets/client13.png';
import Client14 from '../../assets/client14.png';
import Client15 from '../../assets/client15.png';
import Client16 from '../../assets/client16.png';
import Client17 from '../../assets/client17.png';
import Client18 from '../../assets/client18.png';
import Client19 from '../../assets/client19.png';
import Client2 from '../../assets/client2.png';
import Client3 from '../../assets/client3.png';
import Client4 from '../../assets/client4.png';
import Client5 from '../../assets/client5.png';
import Client6 from '../../assets/client6.png';
import Client7 from '../../assets/client7.png';
import Client8 from '../../assets/client8.png';
import Client9 from '../../assets/client9.png';
import { useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { TitleNormalBold } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

// 🔹 애니메이션 정의 (컴포넌트 밖으로 이동)
const scrollLeft = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-33.333%);
  }
`;

// 🔹 styled-components 정의도 컴포넌트 밖으로 이동
const MarqueeContainer = styled.div`
  overflow: hidden;
  width: 100%;
`;

const MarqueeContent = styled.div`
  display: inline-flex;
  animation: ${scrollLeft} 30s linear infinite;
`;

const SlideItem = styled.div`
  width: ${pxToRem(360)};
  margin-right: 32px;
  flex-shrink: 0;
`;

const IntroduceSection7 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();

  const mockData = [
    { img: Client1 },
    { img: Client2 },
    { img: Client3 },
    { img: Client4 },
    { img: Client5 },
    { img: Client6 },
    { img: Client7 },
    { img: Client8 },
    { img: Client9 },
    { img: Client10 },
    { img: Client11 },
    { img: Client12 },
    { img: Client13 },
    { img: Client14 },
    { img: Client15 },
    { img: Client16 },
    { img: Client17 },
    { img: Client18 },
    { img: Client19 },
  ];

  const renderItems = [...mockData, ...mockData, ...mockData];

  return (
    <VerticalLayout style={{ background: 'white', paddingLeft: padding, paddingRight: padding }}>
      <TitleNormalBold fontSize={`${pxToRem(70)}`} color="#000000">
        Our client
      </TitleNormalBold>
      <BTBox height={isMobile ? 23 : `${pxToRem(57)}`} />

      <MarqueeContainer
        style={{
          width: `calc(100% + ${padding * 2}px)`,
          marginLeft: `-${padding}px`,
          marginRight: `-${padding}px`,
          boxSizing: 'border-box',
        }}
      >
        <MarqueeContent>
          {renderItems.map((item, index) => (
            <SlideItem key={index}>
              <img src={item.img} style={{ width: '100%' }} />
            </SlideItem>
          ))}
        </MarqueeContent>
      </MarqueeContainer>

      <BTBox height={isMobile ? 70 : `${pxToRem(190)}`} />
    </VerticalLayout>
  );
};

export default IntroduceSection7;
